import { MediaDraft } from "@home-health-notify/domain";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import React from "react";
import { toPhotoFile } from "../../chats/MediaFiles";
import { AVATAR_SIZE } from "../../utils/AvatarUtils";
import {
  CameraIconButton,
  InputPhotoWrapper,
} from "../../header/userProfile/UserProfileModal.style";
import DisplayAvatarImage from "../../common/DisplayAvatarImage";

type InputGroupPhotoProps = {
  src?: string;
  name: string;
  onImageChange: (uploadedImage: MediaDraft) => void;
};

const InputGroupPhoto = ({
  src,
  name,
  onImageChange,
}: InputGroupPhotoProps) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [imageSrc, setImageSrc] = React.useState(src);
  const uploadPhoto = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setImageSrc(previewUrl);

    const fileWithSafePath = Object.assign(file, {
      filePath: previewUrl,
    });
    const photoFile = toPhotoFile(fileWithSafePath);
    onImageChange(new MediaDraft(photoFile, ""));
  };

  return (
    <InputPhotoWrapper>
      <DisplayAvatarImage
        avatarSize={AVATAR_SIZE.XLARGE}
        alt={name}
        src={imageSrc}
      />

      <CameraIconButton onClick={uploadPhoto}>
        <CameraAltIcon />
      </CameraIconButton>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </InputPhotoWrapper>
  );
};
export default InputGroupPhoto;
